import { attendanceServiceUrl } from "../../../../../../services/http";

export const attendanceServiceEndpoints = {
  gateAttendance: `${attendanceServiceUrl}/external/offline/gate`
}